import { ReactElement } from 'react';

import { AxiosError } from 'axios';
import { ExternalModule } from 'src/router/components';

import { useServicesApi } from ':api/common/useServicesApi';
import {
  BrowserTitle,
  AnalyticsTrackPageView,
  WithHDButtons,
  Preloader,
} from ':components';
import { useServiceId } from ':hooks';
import { ErrorPage } from ':pages';
import { ErrorPageErrorType } from ':pages/ErrorPage';

const errorCodesMap: Record<number, ErrorPageErrorType> = {
  403: 'forbidden',
  404: 'notFound',
  0: 'unknown',
};

export function ModulePage(): ReactElement {
  const url = useServiceId();

  const { data, error, isLoading } = useServicesApi(url);

  if ((error ?? !url) || (!isLoading && !data)) {
    const errorType =
      errorCodesMap[(error as AxiosError).response?.status ?? 0] ??
      errorCodesMap[0];

    return (
      <ErrorPage url={url} errorType={errorType} isHDWidgetForService={false} />
    );
  }

  if (data && data.is_available_by_network === false) {
    return (
      <ErrorPage
        url={url}
        errorType='internalNetwork'
        isHDWidgetForService={true}
      />
    );
  }

  return (
    <WithHDButtons serviceURLName={url}>
      <>
        <BrowserTitle title={data?.name} />
        {isLoading ? (
          <Preloader text='Загрузка данных сервиса...' />
        ) : (
          <>
            <AnalyticsTrackPageView />
            <ExternalModule
              host_url={data?.host_url ?? ''}
              component_id={data?.component_id ?? ''}
            />
          </>
        )}
      </>
    </WithHDButtons>
  );
}
